import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_DOCCURRENTPIECE_SCHEMA_LITERAL = {
    title: 'Schéma CurrentPiece',
    description: 'Document',
    version: 0,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        USER_ID: { type: 'string' },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        DC_PIECE : { type : 'string' }
    },
    required: [ 'MD_SITEGID', 'MD_SITE', 'DC_PIECE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_DOCCURRENTPIECE_SCHEMA_LITERAL);
export type RxCluDocCurrentPieceDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_DOCCURRENTPIECE_SCHEMA: RxJsonSchema<RxCluDocCurrentPieceDocumentType> = CLU_DOCCURRENTPIECE_SCHEMA_LITERAL;
